import { Autocomplete } from "@aws-amplify/ui-react";
import { useContext, useState, useEffect } from "react";
import toast from "react-hot-toast";
import LocalizedStrings from "react-localization";

import { globalStrings } from "config/translations/es";
import { LayoutContext } from "layout/context/LayoutContext";
import { API, graphqlOperation } from "aws-amplify";
import { listUsers } from "graphql/queries";
import { getUser } from "graphql/queries";

const SelectUser = ({ onSelect, placeholder, value }) => {
  const { me } = useContext(LayoutContext);
  const [users, setUsers] = useState({ loading: false, list: [] });
  const [selectedLabel, setSelectedLabel] = useState("");

  useEffect(() => {
    let mounted = true;
    async function fetchSelected() {
      if (!value) {
        setSelectedLabel("");
        return;
      }
      try {
        const userData = await API.graphql(graphqlOperation(getUser, { id: value }));
        const userItem = userData?.data?.getUser;
        if (mounted && userItem) setSelectedLabel(userItem.email || userItem.name || "");
      } catch (err) {
        // ignore
      }
    }
    fetchSelected();
    return () => {
      mounted = false;
    };
  }, [value]);

  const onChangeSelect = (e) => {
    const { value } = e.target;
    if (value) fetchUsers(value);
  };

  async function fetchUsers(email) {
    let filterObj = {};
    try {
      setUsers({ loading: true, list: [] });

      if (me.companyID)
        filterObj = { ...filterObj, or: [{ companyID: { eq: me.companyID } }] };
      if (me.managedCompanies.length > 0)
        filterObj = {
          ...filterObj,
          or: [
            ...(filterObj?.or ?? []),
            ...me.managedCompanies.map((cp) => ({ companyID: { eq: cp } })),
          ],
        };

      const usersData = await API.graphql(
        graphqlOperation(listUsers, {
          filter: {
            and: [{ email: { contains: email } }],
            ...filterObj,
          },
        })
      );
      const usersItems = usersData.data.listUsers.items;
      setUsers((prev) => ({ ...prev, list: usersItems }));
    } catch (err) {
      toast.error(strings.responses.errorFetchData);
    } finally {
      setUsers((prev) => ({ ...prev, loading: false }));
    }
  }

  return (
    <Autocomplete
      placeholder={selectedLabel || placeholder || strings.search}
      options={users.list?.map((it) => ({
        id: it.id,
        label: it.email,
      }))}
      onChange={onChangeSelect}
      isLoading={users.loading}
      onSelect={({ id }) => onSelect(id)}
      onClear={() => onSelect(null)}
      menuSlots={{ Empty: globalStrings.noResults }}
    />
  );
};

const strings = new LocalizedStrings({
  es: {
    search: "Buscar usuario",
  },
});

export default SelectUser;
